import { RemoteLoadWorkLocationList } from '@/javascript/data/usecases'
import { LoadWorkLocationList } from '@/javascript/domain/usecases'
import { makeCurrentAccountHttpClientDecorator } from '@/javascript/main/factories/decorators'
import { makeApiUrl } from '../http'

export const makeRemoteLoadWorkLocationList = (): LoadWorkLocationList =>
  new RemoteLoadWorkLocationList(makeApiUrl('/maps/work_locations'), makeCurrentAccountHttpClientDecorator())